import { apiInstance } from "../config/api";

export const planService = {
  async listPlans() {
    const response = await apiInstance.get("/plan-management/plans");
    return response.data;
  },

  async getPlanById(planId: string) {
    const response = await apiInstance.get(`/plan-management/plans/${planId}`);
    return response.data;
  },

  async makePlanPayment(payload: {
    planId: string;
    profilerId: string;
    durationNumber: number;
    callbackUrl: string;
  }) {
    const response = await apiInstance.post(
      "/plan-management/make-plan-payment",
      payload,
    );
    return response.data;
  },

  async activatePlan(payload: {
    transactionReference: string;
    profilerId: string;
    planId: string;
  }) {
    const response = await apiInstance.post("/plan-management/activate-plan", payload);
    return response.data;
  },

  async getActivePlanPayment(profilerId: string) {
    const response = await apiInstance.get(
      `/plan-management/active-plan-payment/${profilerId}`,
    );
    return response.data;
  },

  async cancelActivePlanPayment() {
    const response = await apiInstance.post(
      "/plan-management/cancel-active-plan-payment",
    );
    return response.data;
  },
};